import React, { useState, useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import {
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Divider,
  Button,
  Typography,
  Tabs,
  Tab,
  Stack,
} from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';
import * as xlsx from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';

import TotalCommonCostStatsContainer from './TotalCommonCostStatsContainer';
import MngCommonCostStatsContainer from './MngCommonCostStatsContainer';
import HqCommonCostStatsContainer from './HqCommonCostStatsContainer';
import TeamCommonCostStatsContainer from './TeamCommonCostStatsContainer';
import HeadCommonCostStatsContainer from './HeadCommonCostStatsContainer';
import { treeDeparts } from '../../modules/deptModule/departs';
import { getHqDepart } from '../../utils/baseCodeUtils';

//----------------------------------------------------------------------

const TABS = [
  { value: 'total', label: '전체', content: <TotalCommonCostStatsContainer /> },
  {
    value: 'management',
    label: '경영기획부',
    content: <MngCommonCostStatsContainer />,
  },
  {
    value: 'headquarter',
    label: '본부별',
    content: <HqCommonCostStatsContainer />,
  },
  {
    value: 'team',
    label: '팀별',
    content: <TeamCommonCostStatsContainer />,
  },
  {
    value: 'head_office',
    label: '본사',
    content: <HeadCommonCostStatsContainer />,
  },
];

//----------------------------------------------------------------------

const CommonCostStatsContainer = () => {
  const totalTableRef = useRef();
  const mngTableRef = useRef();
  const hqTableRef = useRef();
  const teamTableRef = useRef();
  const headTableRef = useRef();

  const dispatch = useDispatch();
  const { departs } = useSelector(({ departModule }) => ({
    departs: departModule.departs.departs,
  }));

  const [selectTab, setSelectedTab] = useState('total');

  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedHq, setSelectedHq] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');

  const [companyHqOptions, setCompanyHqOptions] = useState([]);
  const [HqTeamOptions, setHqTeamOptions] = useState([]);

  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);
  }, []);

  useEffect(() => {
    dispatch(treeDeparts());
  }, [dispatch]);

  useEffect(() => {
    if (departs) {
      const hqs = getHqDepart(departs.children);
      setCompanyHqOptions(hqs);
    }
  }, [departs]);

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleChangeHq = (event) => {
    setSelectedHq(event.target.value);
    //팀 가져오기
    const findTeams = companyHqOptions.find(
      (hq) => hq.id === event.target.value,
    );
    
    setHqTeamOptions(findTeams.children);
  };

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleDownExcel = () => {
    let el;
    let name;
    if (selectTab === 'total') {
      el = totalTableRef;
      name = '전체';
    } else if (selectTab === 'management') {
      el = mngTableRef;
      name = '경영기획부';
    } else if (selectTab === 'headquarter') {
      el = hqTableRef;
      name = '본부별';
    } else if (selectTab === 'team') {
      el = teamTableRef;
      name = '팀별';
    } else if (selectTab === 'head_office') {
      el = headTableRef;
      name = '본부';
    }
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years &&
                  years.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          {selectTab === 'headquarter' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="flex-start"
            >
              <Stack>
                <Typography variant="subtitle2">본부</Typography>
              </Stack>
              <Stack>
                <FormControl variant="standard" size="small" fullWidth>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="selected-hq-label"
                    id="selected-hq"
                    displayEmpty
                    sx={{ width: 240 }}
                    value={selectedHq}
                    onChange={(e) => setSelectedHq(e.target.value)}
                  >
                    <MenuItem value="">본부를 선택하세요</MenuItem>
                    {companyHqOptions &&
                      companyHqOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
          )}
          {selectTab === 'team' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                py: 1,
              }}
            >
              <Stack>
                <Typography variant="subtitle2">본부</Typography>
              </Stack>
              <Stack>
                <FormControl variant="standard" size="small" fullWidth>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="selected-hq-label"
                    id="selected-hq"
                    displayEmpty
                    sx={{ width: 240 }}
                    value={selectedHq}
                    onChange={handleChangeHq}
                  >
                    <MenuItem value="">본부를 선택하세요</MenuItem>
                    {companyHqOptions &&
                      companyHqOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
              <Box>
                <Typography variant="subtitle2">팀</Typography>
              </Box>
              <Box>
                <FormControl variant="standard" size="small" fullWidth>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="selected-team-label"
                    id="selected-team"
                    displayEmpty
                    sx={{ width: 240 }}
                    value={selectedTeam}
                    onChange={(e) => setSelectedTeam(e.target.value)}
                  >
                    <MenuItem value="">팀을 선택하세요</MenuItem>
                    {HqTeamOptions &&
                      HqTeamOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={selectTab}
          onChange={handleChangeTab}
          sx={{ borderBottom: 1, borderColor: 'divider', px: 1 }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>
        <Box sx={{ p: 1 }}>
          {/* {TABS.map(
          (tab) =>
            tab.value === selectTab && (
              <Box key={tab.value} sx={{ p: 2, borderRadius: 1 }}>
                {tab.content}
              </Box>
            ),
        )} */}
          {selectTab === 'total' && (
            <TotalCommonCostStatsContainer
              selectedYear={selectedYear}
              tableRef={totalTableRef}
            />
          )}
          {selectTab === 'management' && (
            <MngCommonCostStatsContainer
              selectedYear={selectedYear}
              tableRef={mngTableRef}
            />
          )}
          {selectTab === 'headquarter' && (
            <HqCommonCostStatsContainer
              selectedYear={selectedYear}
              selectedHq={selectedHq}
              tableRef={hqTableRef}
            />
          )}
          {selectTab === 'team' && (
            <TeamCommonCostStatsContainer
              selectedYear={selectedYear}
              selectedHq={selectedHq}
              selectedTeam={selectedTeam}
              tableRef={teamTableRef}
            />
          )}
          {selectTab === 'head_office' && (
            <HeadCommonCostStatsContainer
              selectedYear={selectedYear}
              tableRef={headTableRef}
            />
          )}
        </Box>
        <Divider />
      </Box>
    </Box>
  );
};
export default CommonCostStatsContainer;
